document.addEventListener('DOMContentLoaded', function () {
  // Run only on homepage
  const isHomePage = window.location.pathname.endsWith('/') || window.location.pathname.endsWith('/index.html');

  if (!isHomePage) return;

  const scrollBtn = document.getElementById('scrollToNext');
  if (!scrollBtn) return;

  scrollBtn.addEventListener('click', function () {
    const scrollOffset = window.innerHeight * 1;
    const targetY = window.scrollY + scrollOffset;
    window.scrollTo({ top: targetY, behavior: 'smooth' });
  });
});
